import { Collapse } from "reactstrap";
import Faq from "./Faq";
import React, { useState } from "react";

export default function MldMarketingFaq(props) {
    const [answers, setAnswers] = useState(new Array(props?.mldMarketingFaq?.length).fill(false));
    const toggle = (ans) => {
        let answer = answers;
        answer[ans] = !answer[ans];
        setAnswers([...answer]);
    };

    return <div className="faq-main section-max-width">
        <p className="inner-title">Frequently asked questions</p>
        {props.mldMarketingFaq && props.mldMarketingFaq.length && props.mldMarketingFaq.map((item, index) => (
            <div key={index}>
                <div
                    className={"title " + (answers[index] ? "title-active" : "")}
                    onClick={() => toggle(index)}>
                    {item.section}
                    <img
                        src={process.env.REACT_APP_IMAGES_PATH + "down-arrow.webp"}
                        alt="arrow"
                        className={answers[index]
                            ? "down-arrow mb-1 ml-2"
                            : "ml-2"}
                    />
                </div>
                {/* <p className="title">{item}</p> */}

                <Collapse isOpen={answers[index]}>
                    <Faq 
                        faqs={item.content}
                        isMobile={props.isMobile}
                    />
                </Collapse>
            </div>
        ))}
    </div>
}